  // Modal for showing upline users
import React, { useEffect, useState } from "react";
import AuthService from "../../../api/services/AuthService";
import LoaderHelper from "../../../customComponent/Loading/LoaderHelper";
import { alertErrorMessage, alertSuccessMessage } from "../../../customComponent/CustomAlertMessage";
import Swal from "sweetalert2";
import moment from "moment";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { CSVLink } from "react-csv";

const ROIDistributionAdmin = () => {
  const [roiList, setRoiList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [distributionDate, setDistributionDate] = useState("");
  const [filteredRoiList, setFilteredRoiList] = useState([]);
  const [periodEndDate, setPeriodEndDate] = useState("");
  const [showUplineModal, setShowUplineModal] = useState(false);
  const [modalSearchTerm, setModalSearchTerm] = useState("");

  useEffect(() => {
    fetchROIData();
  }, []);

  const UplineModal = ({ show, onClose, children }) => {
    if (!show) return null;
    return (
      <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.4)' }} tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content p-3">
            <div className="modal-header">
              <h5 className="modal-title">Upline Users List</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  };
  const fetchROIData = async (endDate = null) => {
    LoaderHelper.loaderStatus(true);
    try {
      const res = await AuthService.getROIForDistribution(endDate);
      if (res?.success) {
        const updatedList = res.data.map((item) => {
          // const selfAmount = item.amount * (item.self_roi_percent / 100);
          const selfAmount = parseFloat(item.period_roi) || 0;
          const upline = item.uplineDistributions.map((dist) => ({
            ...dist,
            updated_amount: dist.period_roi_amount,
            calculated_amount: dist.period_roi_amount,
            // calculated_amount: item.amount * (dist.roi_percent / 100),
            // updated_amount: item.amount * (dist.roi_percent / 100),
          }));
          return {
            ...item,
            self_calculated_amount: selfAmount,
            self_updated_amount: selfAmount,
            roi_distribution: upline,
          };
        });
        setRoiList(updatedList);
        setFilteredRoiList(updatedList);
      }
    } catch (err) {
      alertErrorMessage("Failed to fetch ROI data.");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleFilterByDate = () => {
    if (!periodEndDate) {
      alertErrorMessage("Please select a period end date.");
      return;
    }
    fetchROIData(periodEndDate);
  };

  const handleSelfChange = (index, value) => {
    const updated = [...roiList];
    updated[index].self_updated_amount = parseFloat(value);
    setRoiList(updated);
  };

  const handleUplineChange = (invIndex, distIndex, value) => {
    const updated = [...roiList];
    updated[invIndex].roi_distribution[distIndex].updated_amount = parseFloat(value);
    setRoiList(updated);
  };

  const handleSubmit = async () => {
    if (!distributionDate) {
      alertErrorMessage("Please select a distribution date.");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will distribute ROI to all users.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, distribute it!",
      cancelButtonText: "Cancel",

    });

    if (!result.isConfirmed) return;

    LoaderHelper.loaderStatus(true);
    try {
      const payload = roiList.map((item) => ({
        investmentId: item.investmentId,
        self_amount: item.self_updated_amount,
        payoutDate: distributionDate,
        upline: item.roi_distribution.map((dist) => ({
          user: dist.user,
          level: dist.level,
          currentROI: (dist?.roi_percent || 0),
          currentInvestmentAmount: item?.amount || 0,
          amount: dist.updated_amount,
        })),
      })).filter(item => selectedIds.includes(item.investmentId));
      
      const res = await AuthService.distributePayoutAffiliate(payload);
      if (res.success) {
        setSelectedIds([]);
        setSelectAll(false);
        alertSuccessMessage("ROI distributed successfully");
        fetchROIData();
      } else {
        alertErrorMessage(res.message);
      }
    } catch (err) {
      alertErrorMessage("Submission failed.");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSingleSubmit = async (item) => {
    if (!distributionDate) {
      alertErrorMessage("Please select a distribution date.");
      return;
    }
    const result = await Swal.fire({
      title: `Distribute ROI to ${item.investor?.firstName}?`,
      text: "This will distribute ROI to this user and their uplines.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, distribute",
      cancelButtonText: "Cancel"
    });

    if (!result.isConfirmed) return;

    LoaderHelper.loaderStatus(true);
    try {
      const payload = {
        investmentId: item.investmentId,
        self_amount: item.self_updated_amount,
        payoutDate: distributionDate,
        upline: item.roi_distribution.map((dist) => ({
          user: dist.user,
          level: dist.level,
          currentROI: dist?.roi_percent || 0,
          currentInvestmentAmount: item?.amount || 0,
          amount: dist.updated_amount,
        })),
      };

      const res = await AuthService.distributePayoutAffiliate([payload]);
      if (res.success) {
        alertSuccessMessage("ROI distributed successfully for this user.");
        fetchROIData();
      } else {
        alertErrorMessage(res.message);
      }
    } catch (err) {
      alertErrorMessage("Failed to distribute ROI.");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      setSelectedIds(roiList.map(row => row.investmentId));
    }
    setSelectAll(!selectAll);
  };

  const toggleSelectSingle = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(selectedId => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };
  const searchPackages = (e) => {
    const term = e.target.value.toLowerCase();
    const keysToSearch = ["emailId", "firstName", "lastName",];
    const filtered = roiList.filter(obj =>
      keysToSearch.some(key =>
        obj?.investor?.[key]?.toString().toLowerCase().includes(term)
      )
    );
    setFilteredRoiList(filtered);
  };

  const exportToExcel = () => {
    if (filteredRoiList.length === 0) {
      alertErrorMessage("No data available to export.");
      return;
    }

    const exportData = [];
    
    filteredRoiList.forEach(item => {
      const baseRow = {
        'Investment ID': item.investmentId,
        'Investor Name': `${item.investor?.firstName} ${item.investor?.lastName}`,
        'Email': item.investor?.emailId,
        'Investment Amount': `${item.amount} ${item.currency}`,
        'Investment Date': moment(item.investmentDate).format('MMM DD, YYYY'),
        'ROI Rate': `${parseFloat(item.self_roi_percent)}%`,
        'Days for ROI': item.daysForRoi,
        'Self ROI Amount': item.self_updated_amount ? parseFloat(item.self_updated_amount).toFixed(2) : 0,
        'Level': '',
        'Upline Name': '',
        'Upline Email': '',
        'Upline ROI %': '',
        'Upline Amount': ''
      };

      if (item.roi_distribution.length > 0) {
        item.roi_distribution.forEach((dist, index) => {
          const uplineRow = index === 0 ? { ...baseRow } : {
            'Investment ID': '',
            'Investor Name': '',
            'Email': '',
            'Investment Amount': '',
            'Investment Date': '',
            'ROI Rate': '',
            'Days for ROI': '',
            'Self ROI Amount': '',
            'Level': '',
            'Upline Name': '',
            'Upline Email': '',
            'Upline ROI %': '',
            'Upline Amount': ''
          };
          
          uplineRow['Level'] = `L${dist.level}`;
          uplineRow['Upline Name'] = `${dist.userDetails?.firstName} ${dist.userDetails?.lastName}`;
          uplineRow['Upline Email'] = dist.userDetails?.emailId || '';
          uplineRow['Upline ROI %'] = `${dist.roi_percent}%`;
          uplineRow['Upline Amount'] = parseFloat(dist.updated_amount).toFixed(2);
          
          exportData.push(uplineRow);
        });
      } else {
        exportData.push(baseRow);
      }
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ROI Distribution');
    
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `ROI_Distribution_${moment().format('YYYY-MM-DD')}.xlsx`);
  };

  const exportModalToExcel = (userList) => {
    if (!userList || userList.length === 0) {
      alertErrorMessage("No data available to export.");
      return;
    }

    const exportData = userList.map((user, idx) => ({
      '#': idx + 1,
      'Name': user.name,
      'Email': user.email,
      'Investor ROI': parseFloat(user.period_roi).toFixed(2),
      'Upline ROI': parseFloat(user.period_roi_amount).toFixed(2),
      'Total ROI': (user.period_roi + user.period_roi_amount).toFixed(2)
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Users ROI');
    
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `Users_ROI_${moment().format('YYYY-MM-DD')}.xlsx`);
  };

  const prepareCSVData = () => {
    const csvData = [];
    
    filteredRoiList.forEach(item => {
      const baseRow = {
        'Investment ID': item.investmentId,
        'Investor Name': `${item.investor?.firstName} ${item.investor?.lastName}`,
        'Email': item.investor?.emailId,
        'Investment Amount': `${item.amount} ${item.currency}`,
        'Investment Date': moment(item.investmentDate).format('MMM DD, YYYY'),
        'ROI Rate': `${parseFloat(item.self_roi_percent)}%`,
        'Days for ROI': item.daysForRoi,
        'Self ROI Amount': item.self_updated_amount ? parseFloat(item.self_updated_amount).toFixed(2) : 0,
        'Level': '',
        'Upline Name': '',
        'Upline Email': '',
        'Upline ROI %': '',
        'Upline Amount': ''
      };

      if (item.roi_distribution.length > 0) {
        item.roi_distribution.forEach((dist, index) => {
          const uplineRow = index === 0 ? { ...baseRow } : {
            'Investment ID': '',
            'Investor Name': '',
            'Email': '',
            'Investment Amount': '',
            'Investment Date': '',
            'ROI Rate': '',
            'Days for ROI': '',
            'Self ROI Amount': '',
            'Level': '',
            'Upline Name': '',
            'Upline Email': '',
            'Upline ROI %': '',
            'Upline Amount': ''
          };
          
          uplineRow['Level'] = `L${dist.level}`;
          uplineRow['Upline Name'] = `${dist.userDetails?.firstName} ${dist.userDetails?.lastName}`;
          uplineRow['Upline Email'] = dist.userDetails?.emailId || '';
          uplineRow['Upline ROI %'] = `${dist.roi_percent}%`;
          uplineRow['Upline Amount'] = parseFloat(dist.updated_amount).toFixed(2);
          
          csvData.push(uplineRow);
        });
      } else {
        csvData.push(baseRow);
      }
    });

    return csvData;
  };

  return (
    <div id="layoutSidenav_content">
      <style>
        {`
          .date-input-custom::-webkit-calendar-picker-indicator {
            filter: invert(1);
            cursor: pointer;
          }
          .date-input-custom::-webkit-inner-spin-button,
          .date-input-custom::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
        `}
      </style>
      <UplineModal show={showUplineModal} onClose={() => setShowUplineModal(false)}>
        {/* Aggregate and display upline users */}
        {(() => {
          // Map to cumulate both investors and uplines by email
          const userMap = {};
          // 1. Add/cumulate investors
          roiList.forEach(item => {
            const investor = item.investor;
            if (investor && investor.emailId) {
              const key = investor.emailId;
              if (!userMap[key]) {
                userMap[key] = {
                  name: `${investor.firstName || ''} ${investor.lastName || ''}`.trim(),
                  email: investor.emailId,
                  period_roi: 0,
                  period_roi_amount: 0
                };
              }
              userMap[key].period_roi += parseFloat(item.period_roi) || 0;
            }
          });
          // 2. Add/cumulate uplines
          let to = 0;
          roiList.forEach(item => {
            (item.roi_distribution || []).forEach(dist => {
              const u = dist.userDetails;
              if (!u || !u.emailId) return;
              const key = u.emailId;
              if (!userMap[key]) {
                userMap[key] = {
                  name: `${u.firstName || ''} ${u.lastName || ''}`.trim(),
                  email: u.emailId,
                  period_roi: 0,
                  period_roi_amount: 0
                };
              }
              if(key == "piyushkrishnav@gmail.com"){
                to += parseFloat(dist.period_roi_amount) || 0;
                console.log("Debug Upline:", dist.period_roi_amount);
                console.log("Debug Total:", to);
              }
              userMap[key].period_roi_amount += parseFloat(dist.period_roi_amount) || 0;
            });
          });
          // 3. Prepare list and filter by search term
          let userList = Object.values(userMap);
          if (modalSearchTerm) {
            const term = modalSearchTerm.toLowerCase();
            userList = userList.filter(user => 
              user.name.toLowerCase().includes(term) || 
              user.email.toLowerCase().includes(term)
            );
          }
          if (userList.length === 0) {
            return <div>No users found.</div>;
          }
          return (
            <div>
              <div className="mb-3 d-flex gap-2">
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Search by name or email..."
                  value={modalSearchTerm}
                  onChange={(e) => setModalSearchTerm(e.target.value)}
                />
                <button 
                  className="btn btn-success btn-sm text-nowrap" 
                  onClick={() => exportModalToExcel(userList)}
                >
                  <i className="fas fa-file-excel me-1"></i>
                  Export
                </button>
              </div>
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Investor ROI</th>
                    <th>Upline ROI</th>
                    <th>Total ROI</th>
                  </tr>
                </thead>
                <tbody>
                  {userList.map((user, idx) => (
                    <tr key={user.email}>
                      <td>{idx + 1}</td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.period_roi.toFixed(2)}</td>
                      <td>{user.period_roi_amount.toFixed(2)}</td>
                      <td>{(user.period_roi + user.period_roi_amount).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })()}
      </UplineModal>
      <main>
        <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
          <div className="container-xl px-4">
            <div className="page-header-content pt-4">
              <h1 className="page-header-title">
                <div className="page-header-icon"><i className="fas fa-coins" /></div>
                ROI Distribution Panel
              </h1>
            </div>
          </div>
        </header>

        <div className="container-xl px-4 mt-n10">
          <div className="mb-3 d-flex justify-content-end">
            <button className="btn btn-info btn-sm" onClick={() => setShowUplineModal(true)}>
              Show Popup
            </button>
          </div>
          <div className="card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
              <span>Distribute ROI</span>
              <div className="d-flex gap-2 align-items-center flex-grow-1 justify-content-center">
                <div className="col-3">
                  <input style={{ border: "1px solid #ccc" }}
                    className="form-control form-control-solid"
                    type="text"
                    placeholder="Search here..."
                    onChange={searchPackages}
                  />
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <label className="mb-0 text-nowrap">Period End Date:</label>
                  <input 
                    type="date" 
                    className="form-control form-control-sm date-input-custom" 
                    value={periodEndDate} 
                    onChange={(e) => setPeriodEndDate(e.target.value)}
                    style={{ width: '150px' }}
                  />
                  <button 
                    className="btn btn-primary btn-sm"
                    onClick={handleFilterByDate}
                  >
                    <i className="fas fa-filter me-1"></i>
                    Filter
                  </button>
                </div>
              </div>
              <div className="d-flex gap-2">
                <input type="date" className="form-control form-control-sm date-input-custom" value={distributionDate} onChange={(e) => setDistributionDate(e.target.value)} />
                
                {/* Export Dropdown */}
                {filteredRoiList.length > 0 && (
                  <div className="dropdown">
                    <button className="btn btn-success btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Export
                    </button>
                    <div className="dropdown-menu">
                      <CSVLink 
                        data={prepareCSVData()} 
                        filename={`ROI_Distribution_${moment().format('YYYY-MM-DD')}.csv`}
                        className="dropdown-item"
                      >
                        Export as CSV
                      </CSVLink>
                      <button className="dropdown-item" onClick={exportToExcel}>
                        Export as Excel
                      </button>
                    </div>
                  </div>
                )}

                <button className="btn btn-success btn-sm" disabled={selectedIds?.length === 0} onClick={handleSubmit}>
                  Distribute to Selected ({selectedIds.length})
                </button>
              </div>
            </div>

            <div className="card-body">
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectAll}
                    onChange={toggleSelectAll}
                  />
                  <label className="form-check-label">
                    Select All ({filteredRoiList.length})
                  </label>
                </div>
              </div>

              <div className="row g-3">
                {filteredRoiList.map((item, index) => (
                  <div key={item._id} className="col-12 py-0">
                    <div className="card border shadow-sm ">
                      <div className="card-body p-0">
                        <div>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={selectedIds.includes(item.investmentId)}
                            onChange={() => toggleSelectSingle(item.investmentId)}
                          />
                        </div>
                        <div className="row align-items-center">


                          {/* Investor Info Column */}
                          <div className="col-lg-2 col-md-4 col-sm-4 d-flex">


                            <div>
                              <h6 className="mb-1">{item.investor?.firstName} {item.investor?.lastName}</h6>
                              <small className="text-muted">{item.investor?.emailId}</small>
                            </div>
                          </div>

                          {/* Email Column */}
                          {/* <div className="col-lg-2 col-md-3">
                            <small className="text-muted d-block">Email</small>
                            <div className="text-break small">{item.investor?.emailId}</div>
                          </div> */}

                          {/* Investment Column */}
                          <div className="col-lg-2 col-md-4 col-sm-4 text-center">
                            {/* <small className="text-muted d-block">Investment/ROI Rate</small> */}
                            <strong className="text-success">{item.amount} {item.currency}</strong>
                            <div className="small">{parseFloat(item.self_roi_percent)}% / {item.daysForRoi}d</div>
                            <small className="text-muted">{moment(item?.investmentDate).format('MMM DD, YYYY')}</small>
                          </div>

                          {/* ROI Rate Column */}
                          {/* <div className="col-lg-1 col-md-2">
                            <small className="text-muted d-block">ROI Rate</small>
                            <div className="small">{item.self_roi_percent}% / {item.daysForRoi}d</div>
                          </div> */}

                          {/* Self ROI Amount Column */}
                          <div className="col-lg-2 col-md-4 col-sm-4">
                            <small className="text-muted d-block">Self ROI Amount</small>
                            <input
                              type="text"
                              className="form-control form-control-sm mt-1"
                              value={(item.self_updated_amount)? parseFloat(item.self_updated_amount).toFixed(0) : 0}
                              onChange={(e) => handleSelfChange(index, e.target.value)}
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>

                          {/* Upline Distribution Column */}
                          <div className="col-lg-6 col-md-12  col-sm-12 d-flex align-items-center justify-content-between">
                            <div style={{ flexGrow: 1 }}>
                              <small className="text-muted d-block mb-2">Upline Distribution</small>
                              {item.roi_distribution.length > 0 ? (
                                <div className="border border-dark rounded py-2 " style={{ overflowY: "auto" }}>
                                  {item.roi_distribution.map((dist, i) => (
                                    <div key={i} className="d-flex align-items-center mb-2 small">
                                      <span className="badge me-1">L{dist.level}</span>
                                      <div className="flex-grow-1 me-1">
                                        <div className="fw-semibold">{dist.userDetails?.firstName} {dist.userDetails?.lastName}</div>
                                        <div className="text-muted">{dist.roi_percent}%</div>
                                      </div>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        style={{ width: "50%" }}
                                        value={parseFloat(dist.updated_amount).toFixed(0)}
                                        onChange={(e) => handleUplineChange(index, i, e.target.value)}
                                        onWheel={(e) => e.target.blur()}
                                      />
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <span className="text-muted small">No upline</span>
                              )}
                            </div>
                            <button
                              className="btn btn-primary btn-sm ms-3" style={{ width: "100px" }}
                              onClick={() => handleSingleSubmit(item)}
                            >
                              <i className="fas fa-coins me-1"></i>
                              Distribute
                            </button>
                          </div>

                          {/* Action Column */}
                          {/* <div className="col-lg-1 col-md-3">
                            <button
                              className="btn btn-primary btn-sm w-100"
                              onClick={() => handleSingleSubmit(item)}
                            >
                              <i className="fas fa-coins me-1"></i>
                              Distribute
                            </button>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {roiList.length === 0 && (
                <div className="text-center py-5">
                  <img src="/assets/img/no-data.png" alt="No Data" width="100" className="mb-3" />
                  <h5 className="text-muted">No ROI distribution data available</h5>
                  <p className="text-muted">There are no investments ready for ROI distribution at this time.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ROIDistributionAdmin;
